import { HEADER_TRANSLATION_KEY } from '../constants';

export default {
  es: {
    [HEADER_TRANSLATION_KEY]: {
      HEADER_ID_0_NAME: 'Partners',
      HEADER_ID_0_ITEM_1_NAME: 'Revendedores',
      HEADER_ID_0_ITEM_1_DESCRIPTION:
        'Impulsa el desarrollo profesional de las personas.',
      HEADER_ID_0_ITEM_2_NAME: 'Referidos',
      HEADER_ID_0_ITEM_2_DESCRIPTION: 'Recomienda Crehana a tu empresa.',

      HEADER_ID_1_NAME: 'Producto',
      HEADER_ID_1_ITEM_1_NAME: 'Skill XP',
      HEADER_ID_1_ITEM_1_DESCRIPTION:
        'Conoce las necesidades de estudio de tus empleados.',
      HEADER_ID_1_ITEM_2_NAME: 'Mentorías',
      HEADER_ID_1_ITEM_2_DESCRIPTION:
        'Siempre aprenderás en compañía de expertos.',
      HEADER_ID_1_ITEM_3_NAME: 'Studios',
      HEADER_ID_1_ITEM_3_DESCRIPTION:
        'Comparte material exclusivo de tu empresa.',
      HEADER_ID_1_ITEM_4_NAME: 'Análisis de Data',
      HEADER_ID_1_ITEM_4_DESCRIPTION: 'Accede a estadísticas en tiempo real.',

      HEADER_ID_2_NAME: 'Academias',
      HEADER_ID_2_GROUP_1_TITLE: 'NUESTRAS ACADEMIAS',
      HEADER_ID_2_GROUP_1_SUBITEM_1_NAME: 'Liderazgo',
      HEADER_ID_2_GROUP_1_SUBITEM_1_DESCRIPTION: 'Descubre tu potencial.',
      HEADER_ID_2_GROUP_1_SUBITEM_2_NAME: 'Innovación',
      HEADER_ID_2_GROUP_1_SUBITEM_2_DESCRIPTION: 'Potencia tu creatividad.',
      HEADER_ID_2_GROUP_1_SUBITEM_3_NAME: 'Marketing Digital',
      HEADER_ID_2_GROUP_1_SUBITEM_3_DESCRIPTION: 'Conoce el mundo digital.',
      HEADER_ID_2_GROUP_1_SUBITEM_4_NAME: 'Ventas',
      HEADER_ID_2_GROUP_1_SUBITEM_4_DESCRIPTION: 'Fideliza a tus clientes.',
      HEADER_ID_2_GROUP_2_TITLE: 'NUESTRAS RUTAS DE APRENDIZAJE',
      HEADER_ID_2_GROUP_2_SUBITEM_1_NAME: 'Digital Mindset',
      HEADER_ID_2_GROUP_2_SUBITEM_1_DESCRIPTION: 'Lidera la transformación.',
      HEADER_ID_2_GROUP_2_SUBITEM_2_NAME: 'Análisis de Data',
      HEADER_ID_2_GROUP_2_SUBITEM_2_DESCRIPTION: 'Administra estadísticas.',
      HEADER_ID_2_GROUP_2_SUBITEM_3_NAME: 'E-commerce',
      HEADER_ID_2_GROUP_2_SUBITEM_3_DESCRIPTION: 'Crear estrategias online.',
      HEADER_ID_2_GROUP_2_SUBITEM_4_NAME: 'UI & UX',
      HEADER_ID_2_GROUP_2_SUBITEM_4_DESCRIPTION: 'Optimiza tu diseño web.',

      HEADER_ID_3_NAME: 'Recursos',
      HEADER_ID_3_ITEM_1_NAME: 'Blog',
      HEADER_ID_3_ITEM_1_DESCRIPTION:
        'Contenido relevante para tu aprendizaje.',
      HEADER_ID_3_ITEM_2_NAME: 'Descargables',
      HEADER_ID_3_ITEM_2_DESCRIPTION: 'Ebooks, herramientas, top-cases y más.',

      HEADER_ID_4_NAME: 'Planes',

      HEADER_CALL_BUTTON: 'Llámanos',
      HEADER_FREE_TRIAL_BUTTON: 'Pruébalo gratis',
      HEADER_FORM_PHONE_LABEL: 'Número de telefono',
      HEADER_FORM_PHONE_ERROR: 'Ingresar número válido',
      HEADER_FORM_PHONE_BUTTON: 'Contactar',

      HEADER_CONTACT_DIALOG_TITLE:
        'Contáctate con nuestro equipo \n de expertos',
      HEADER_CONTACT_DIALOG_DESCRIPTION:
        'Estamos disponibles de Lunes a Viernes de 9am a 6pm (PET)',

      HEADER_CONFIRMATION_DIALOG_TITLE:
        'Muchas gracias por \n registrar tus datos',
      HEADER_CONFIRMATION_DIALOG_DESCRIPTION:
        'En breve nos estaremos comunicando contigo \n para que vivas esta experiencia.',
      HEADER_CONFIRMATION_DIALOG_BUTTON: 'Finalizar',

      CLE_CTA: 'Conoce más',
      CLE_TITLE: 'Ecosistema de Desarrollo de Personas',
      CLE_DESCRIPTION:
        'Antes de elegir un programa de training para tu equipo, asegúrate de que podrás contar con las estadísticas necesarias para saber el impacto que generará.',
    },
  },
};
